import { LinearProgress, styled } from '@mui/material';

export const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 64,
  border: `2px solid ${theme.palette.secondary[500]}`,
  borderRadius: '0.25rem',
  backgroundColor: 'white',
  '&&& .MuiLinearProgress-barColorPrimary': {
    backgroundColor: `${theme.palette.secondary[200]}`,
  },
}));
